import { render, staticRenderFns } from "./updHokl.vue?vue&type=template&id=3e844b86&scoped=true"
import script from "./updHokl.vue?vue&type=script&lang=js"
export * from "./updHokl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e844b86",
  null
  
)

export default component.exports